import { useQuery } from "react-query";
import { dictionaryService } from "../../../../reportng/dataFlow";
import { dimensionItemsKey, measuresUrl, fieldsUrl } from "./dimensionItems.constants";
import { createConfigurationItems, createModelItems } from "./dimensionItems.adapter";
import { virtualConfiguration } from "../../../components/BulkExportStepper";
import { getJSON } from "../../../../http";

export function useDimensionItemsQuery(lcid: number, dataSourceId?: number, dictionaryIdentifier?: string) {
  let queryKey =  `${dimensionItemsKey}/${dictionaryIdentifier}`;
  if(isConfigurationDictionary(dictionaryIdentifier)) {
    queryKey += `/${dataSourceId}`;
  }

  const { isLoading, error, data } = useQuery(
    queryKey,
    () => !(dictionaryIdentifier && dataSourceId) ? undefined : getDictionaryItems(dataSourceId!, dictionaryIdentifier, lcid),
    { cacheTime: 0, staleTime: 0 }
  );
  
  return { isDimensionItemsLoading: isLoading, dimensionItemsError: error, dimensionItems: data };
}

async function getDictionaryItems(dataSourceId: number, dictionaryIdentifier: string, lcid?: number) {
  if (!isConfigurationDictionary(dictionaryIdentifier)) {
    const dictionary = await dictionaryService.getDictionary({
      id: dictionaryIdentifier,
      parameters: {},
    });

    const dictionaryItems = await dictionary.getAll();

    return createModelItems(dictionaryItems, lcid);
  }

  const measuresPrms = getJSON<{ id: string, name: string }[]>(`${measuresUrl}/${dataSourceId}`);
  const fieldsPrms = getJSON<{ identifier: string, name: string }[]>(`${fieldsUrl}/${dataSourceId}`);

  const [measures, fields] = await Promise.all([measuresPrms, fieldsPrms]);

  return createConfigurationItems(measures, fields);
}

function isConfigurationDictionary(dictionaryIdentifier?: string) {
  return dictionaryIdentifier === virtualConfiguration.identifier;
}